import __, { isEmpty, map, some } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';

import { MODULE_FILTER_TABLE } from '../../utils/constants';
import styles from './CustomFilterTable.module.scss';
import Spinner from '../Loading/Spinner';
import Checkbox from '../CheckBox/CheckBox';

export const CustomFilterTable = ({
  _setSelectedKeys,
  selectedKeys,
  filters,
  isLoading,
  onApplyFilters,
  close,
  moduleName,
  filterName,
  customStyle = {},
}) => {
  const [selectedFilters, setSelectedFilters] = useState([]);

  useEffect(() => {
    setSelectedFilters(
      map(filters, (filter) => ({
        label: filter.text,
        value: filter.value,
        isChecked: some(selectedKeys, (selected) => selected === filter.value),
      }))
    );
  }, [filters, selectedKeys]);

  const handleSelectFilter = useCallback((filters) => {
    setSelectedFilters(
      map(filters, (filter) => {
        return { text: filter.label, ...filter };
      })
    );
  }, []);

  const handleApply = useCallback(() => {
    const selectedKeys = __(selectedFilters)
      .filter((filter) => filter.isChecked)
      .map('value')
      .value();

    if ([MODULE_FILTER_TABLE.LIST_OF_USER_DETAILS].includes(moduleName)) {
      onApplyFilters(filterName, selectedKeys);
    } else {
      onApplyFilters(selectedKeys);
    }
    close();
  }, [selectedFilters, onApplyFilters, close]);

  if (isLoading) {
    return (
      <div className={styles.flex_center}>
        <Spinner />
      </div>
    );
  }

  if (isEmpty(filters)) {
    return <div className={styles.flex_center}>No Filters</div>;
  }

  return (
    <>
      <div>
        <div className={styles.dropdown__filters} style={customStyle}>
          {!isEmpty(selectedFilters) &&
            [MODULE_FILTER_TABLE.COMPLEMENTARY_EXPERIENCE, MODULE_FILTER_TABLE.VERBATIM_FEEDBACK, MODULE_FILTER_TABLE.LIST_OF_USER_DETAILS].includes(
              moduleName
            ) && (
              <Checkbox
                item={{ label: '(Select All)', value: 'all' }}
                select={selectedFilters}
                setSelect={handleSelectFilter}
                customStyle={true}
                filterName={filterName}
              />
            )}
          {map(selectedFilters, (filter) => (
            <Checkbox
              key={filter.value}
              item={filter}
              select={selectedFilters}
              setSelect={handleSelectFilter}
              customStyle={true}
              filterName={filterName}
            />
          ))}
          {!isEmpty(selectedFilters) &&
            ![MODULE_FILTER_TABLE.COMPLEMENTARY_EXPERIENCE, MODULE_FILTER_TABLE.VERBATIM_FEEDBACK, MODULE_FILTER_TABLE.LIST_OF_USER_DETAILS].includes(
              moduleName
            ) && (
              <Checkbox
                item={{ label: 'All', value: 'all' }}
                select={selectedFilters}
                setSelect={handleSelectFilter}
                customStyle={true}
                filterName={filterName}
              />
            )}
        </div>
        <div
          className={
            ![MODULE_FILTER_TABLE.COMPLEMENTARY_EXPERIENCE, MODULE_FILTER_TABLE.LIST_OF_USER_DETAILS].includes(moduleName)
              ? styles.dropdown__apply
              : styles.dropdown__apply_complementary
          }
        >
          <button className={styles.dropdown__btn} onClick={handleApply}>
            Apply
          </button>
        </div>
      </div>
    </>
  );
};
